import { rpc } from '@server/infrastructure/rpc'

import { getBearerToken } from '../../authentication'

/**
 * 가입 후 이탈자 프로모션 자격 조회
 */
export const getSignupDropoutPromotion = async (bearerToken?: string) => {
  const authorizationToken = bearerToken ?? (await getBearerToken())
  const response = await rpc.api.v1.users['signup-dropout-promotion'].$get(
    {},
    { headers: { Authorization: `Bearer ${authorizationToken}` } },
  )

  if (!response.ok) {
    throw new Error(`Failed to fetch signup dropout promotion: ${response.status}`)
  }

  return response.json()
}

export type SignupDropoutPromotionResponse = Awaited<ReturnType<typeof getSignupDropoutPromotion>>
